import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;
